import React, { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import api from '../../utils/api'

const REFUND_KIND_LABELS = { partial: '部分退款', full: '全额退款' }

export default function RefundLogsModal({ open, order, onClose }) {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open || !order?.order_no) return
    let cancelled = false
    setLoading(true)
    setLogs([])
    api.get('/payment/admin/refund-logs', { params: { orderNo: order.order_no } })
      .then((res) => {
        if (!cancelled && res.data.success) {
          // 拦截器会将 data 平铺合并（res.data.list），同时兼容未合并的情况
          setLogs(res.data.list || res.data.data?.list || [])
        }
      })
      .catch((e) => {
        console.error('获取退款记录失败:', e)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [open, order?.order_no])

  if (!open || !order) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-2xl rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold text-gray-900">退款记录</h3>
        <p className="mt-2 text-sm text-gray-600">订单号：{order.order_no}</p>

        <div className="mt-4 max-h-96 overflow-y-auto rounded-lg border border-gray-200">
          {loading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
            </div>
          ) : logs.length === 0 ? (
            <div className="py-8 text-center text-sm text-gray-500">暂无退款记录</div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="sticky top-0 bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">时间</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">类型</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">退款金额</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">订单原金额</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">操作员</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">状态</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">备注/原因</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td className="whitespace-nowrap px-3 py-2 text-gray-700">
                      {new Date(log.created_at).toLocaleString('zh-CN', { hour12: false })}
                    </td>
                    <td className="whitespace-nowrap px-3 py-2 text-gray-700">{REFUND_KIND_LABELS[log.refund_kind] || log.refund_kind}</td>
                    <td className="whitespace-nowrap px-3 py-2 font-medium text-red-600">¥{Number(log.refund_amount).toFixed(2)}</td>
                    <td className="whitespace-nowrap px-3 py-2 text-gray-700">¥{Number(log.order_amount).toFixed(2)}</td>
                    <td className="whitespace-nowrap px-3 py-2 text-gray-700">{log.operator_name || '-'}</td>
                    <td className="whitespace-nowrap px-3 py-2">
                      {log.status === 1 ? (
                        <span className="text-green-600">成功</span>
                      ) : (
                        <span className="text-red-600">资金异常</span>
                      )}
                    </td>
                    <td className="px-3 py-2 text-gray-500">
                      {log.fail_reason || log.remark || '-'}
                      {log.out_refund_no && <div className="text-xs text-gray-400">单号: {log.out_refund_no}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  )
}
